import React from 'react'
import { VectorSearchFilters, FilterLabels, SearchFilter } from '../../../../lib/types'
import { TextInputFilter } from './Filters/TextInputFilter'
import { TypeAheadFilter } from './Filters/TypeAheadFilter'

type SelectedFiltersProps = {
  searchFilters: SearchFilter | undefined
  selectedFilters: VectorSearchFilters 
  onRemove: (term: string, value: string) => void
  onAdd: (term: string, value: string) => void
  currency: string
}

export const SelectedFilters = (props: SelectedFiltersProps) => {
  const { selectedFilters, onRemove, searchFilters, onAdd } = props
  const { jobTitle, jobDescription } = selectedFilters
  const pillGroupsTerms = ['publisher', 'surveyCodeSurveyShortName']

  return (
    <>
      <TextInputFilter
        textValue={jobTitle}
        selectedFilters={selectedFilters}
        term='jobTitle'
        placeholder='Search for Job Title'
        onRemove={onRemove}
        onAdd={onAdd}
      />
      <TextInputFilter
        textarea
        w={900}
        textValue={jobDescription}
        selectedFilters={selectedFilters}
        term='jobDescription'
        placeholder='Search for Job Description'
        onRemove={onRemove}
        onAdd={onAdd}
      />
      {pillGroupsTerms.map((term: keyof typeof FilterLabels) => (
        <TypeAheadFilter
          term={term}
          selectedFilters={selectedFilters}
          searchFilters={searchFilters}
          onAdd={onAdd}
          onRemove={onRemove}
        />
      ))}
    </>
  )
}
